import { render, staticRenderFns } from "./Trainings.vue?vue&type=template&id=499041ad&scoped=true&"
import script from "./Trainings.vue?vue&type=script&lang=js&"
export * from "./Trainings.vue?vue&type=script&lang=js&"
import style0 from "./Trainings.vue?vue&type=style&index=0&id=499041ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499041ad",
  null
  
)

component.options.__file = "Trainings.vue"
export default component.exports